import { useTranslation } from 'react-i18next';
import { useVisibleProgress } from '../context/VisibleHealthContext';
import type { ItemsTableRow } from '../types';
import { ProgressCell } from './ProgressCell';
import { CellTextSkeleton } from './withSkeleton';

export const ProgressTableCell = ({ row }: { row: ItemsTableRow }) => {
  const { t } = useTranslation();
  const progress = useVisibleProgress(row.id);

  if (progress === undefined) return <CellTextSkeleton />;
  if (progress === null) return null;

  return (
    <ProgressCell
      value={progress * 100}
      min={0}
      max={100}
      label={t(($) => $.views.table.columns.systemFields.progress)}
    />
  );
};
